import './builders/suggestions/campus_builder.es.js';
import './builders/suggestions/course_builder.es.js';
import './builders/suggestions/location_builder.es.js';
import './builders/suggestions/mapping_functions/mapping_functions.es.js';
import './builders/suggestions/program_builder.es.js';
import './builders/suggestions/required_section_builder.es.js';
import './builders/suggestions/section_builder.es.js';
import './builders/suggestions/section_status_builder.es.js';
import './builders/suggestions/section_status_collection_builder.es.js';
import './builders/suggestions/section_time_builder.es.js';
import './builders/suggestions/section_type_builder.es.js';
import './builders/suggestions/term_builder.es.js';
import './builders/waitlist_status_builder.ts';
import './commands/drop_course_sections_command.ts';
import './commands/get_course_scheduler_command.ts';
import './commands/get_pusher_seats_available_command.ts';
import './commands/get_scheduler_config_command.ts';
import './commands/register_scheduled_sections_command.ts';
import '../../registration_receipt/commands/registration_reciept_command.ts';
import './commands/select_all_registration_sections_command.ts';
import './commands/unschedule_course_sections_command.ts';
import './commands/unschedule_section_command.ts';
import './components/calendar_placeholder_alert/calendar_placeholder_alert.ts';
import './components/calendar_placeholder_alert/openModalFlag.ts';
import './components/linked_section_message/linked_section_message.ts';
import './components/multi_section_message/multi_section_message.ts';
import './components/multi_section_sections_required_tile/multi_section_sections_required_tile.ts';
import './components/register_sections_button/register_sections_button.ts';
import './components/section_tile_checkbox/section_tile_checkbox.ts';
import './components/scheduled_section_coreq_prereq_message/scheduled_section_coreq_prereq_message.ts';
import './components/scheduled_section_menu/scheduled_section_menu.ts';
import './components/scheduled_section_notification/scheduled_section_notification.ts';
import './components/scheduled_section_status_label/scheduled_section_status_label.ts';
import './components/scheduled_section_tile/scheduled_section_tile_component.ts';
import './components/scheduled_section_waitlist_message/scheduled_section_waitlist_message.ts';
import './components/scheduled_sections/scheduled_sections_component.ts';
import './components/section_group/section_group_component.ts';
import './components/section_tile_error/section_tile_error.ts';
import './components/section_tile_error_section_required/section_tile_error_section_required.ts';
import './datasources/waitlist_status_datasource.ts';
import './filters/register_sections_filters.ts';
import './filters/register_waitlist_filters.ts';
import './filters/scheduled_section_filters.ts';
import './modals/suggestions/builders/suggestions_builder.js';
import './modals/suggestions/commands/load_suggestions_command.js';
import './modals/suggestions/commands/save_suggestions_command.ts';
import './modals/suggestions/components/campus_list/campus_list.js';
import './modals/suggestions/services/suggestions_service.js';
import './modals/suggestions/suggestions.js';
import './datasources/register_sections_datasource.ts';
import './models/registration_failure_model.ts';
import '../../registration_receipt/models/registration_reciept_model.ts';
import './models/registration_waitlist_position_model.ts';
import './models/scheduler_model.ts';
import './queries/register_sections_query.ts';
import '../../registration_receipt/queries/registration_receipt_query.ts';
import './queries/scheduled_sections_query.ts';
import './servants/cross_course_linked_section_servant.ts';
import './servants/multi_section_servant.ts';
import './servants/registration_alerts_servant.ts';
import './servants/registration_callback_servant.ts';
import './servants/registration_receipt_servant.ts';
import './servants/requisite_course_servant.ts';
import './servants/scheduled_section_servant.ts';
import './servants/scheduled_section_status_servant.ts';
import './servants/scheduled_section_tile_servant.ts';
import './servants/waitlist_callback_servant.ts';
import './services/term_schedule_flags.ts';
import './strategies/registration_waitlist_outcome_status_strategy.ts';
import './strategies/section_status_label_strategy.ts';
import './strategies/section_tile_error_strategy.ts';
import './types/registration_alert_messages.ts';
import './types/requisite_enum.ts';
import './types/scheduled_section_status_enum.ts';
import './types/section_tile_error_enum.ts';
import './types/section_tile_menu_enum.ts';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/index.ts